import { render, staticRenderFns } from "./AddAward.vue?vue&type=template&id=21f03392&scoped=true"
import script from "./AddAward.vue?vue&type=script&lang=js"
export * from "./AddAward.vue?vue&type=script&lang=js"
import style0 from "./AddAward.vue?vue&type=style&index=0&id=21f03392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f03392",
  null
  
)

export default component.exports